<template>
    <div class="p-col-12">
        <div class="card">
            <ancestryline-data-table :data-function="dataFunction" :columns="columns" :quantity-rows="quantityPerPage" :default-filter="defaultFilter || filters" ref="protocollistdatatable"/>
        </div>
    </div>
</template>

<script>
    import AncestrylineDataTable from "@/components/table/AncestrylineDataTable";
    import FrontBusiness from "@/business/FrontBusiness";
    import ProtocolBusiness from "@/business/ProtocolBusiness";
    import DialogService from "@/business/ModalBusiness";
    import ModalProtocolFilter from "@/viewer/protocol/ModalProtocolFilter";
    import {ACTIVE} from "@/constants/StatusProtocol";

    export default {
        name: "ShortProtocolList",
        components: {AncestrylineDataTable},

        props: {
          defaultFilter: null,
          quantityPerPage: {default: () => {return 5}},
        },

        data() {
            return {
                filters: {name: null, code: null, family_name: null, person_id: null, budget: null, status: ACTIVE},
                clientFilterTemp: null,
                dataFunction: ProtocolBusiness.pagination,
                columns: [
                    {field: "code", header: !this.defaultFilter ? 'dataTable.protocol.columns.protocol' : 'dataTable.protocol.columns.budget', sortable:true, type: 'actions', customFunction: this.protocolName,
                        actions: [
                            {type: 'protocolLink', title: 'dataTable.protocol.columns.protocol'},
                        ], style: 'width: 150px;',
                    },
                    {field: "name", header: 'dataTable.protocol.columns.name', sortable:true, type: 'actions',
                      actions: [
                        {type: 'protocolLink', title: 'dataTable.protocol.columns.protocol'},
                      ], style: 'width: 250px;',
                    },
                    {field: "typeServiceName", header: 'dataTable.protocol.columns.type-service', sortable:true},
                ],
            }
        },

        methods: {

            protocolName: ProtocolBusiness.protocolName,

            protocolDetails(protocol){
              FrontBusiness.redirect(`/protocol/${protocol.id}`);
            },

            async openFilterModal(){
              if(this.clientFilterTemp){
                this.$set(this.filters, 'person_id', this.clientFilterTemp);
              }
              const filters = await DialogService.openModal(ModalProtocolFilter, {filters: this.filters});
              if(filters){
                if(filters.person_id instanceof Object){
                  this.clientFilterTemp = filters.person_id;
                  filters.person_id = filters.person_id.id;
                } else {
                  this.clientFilterTemp = null;
                }
                this.$set(this.$refs.protocollistdatatable, 'filters', filters);
                this.$set(this, 'filters', filters);
                await this.$refs.protocollistdatatable.loadPage();
              }
            },

        }

    }
</script>

<style scoped>

</style>
